import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CreditCard, Check, Sparkles } from "lucide-react";

const PLANS = [
  { name: "Small", price: 299, monthly: 100, total: 300, color: "#2563EB", testid: "subscription-plan-small" },
  { name: "Medium", price: 599, monthly: 200, total: 600, color: "#7C3AED", testid: "subscription-plan-medium", popular: true },
  { name: "Large", price: 899, monthly: 500, total: 1500, color: "#059669", testid: "subscription-plan-large" },
];

export default function SubscriptionTab({ stats, onNavigate }) {
  const used = stats?.receipts_this_month ?? 0;
  return (
    <div className="space-y-6" data-testid="subscription-tab">
      <div>
        <h2 className="font-display text-xl font-semibold flex items-center gap-2"><CreditCard className="h-5 w-5 text-indigo-600" /> Subscription</h2>
        <p className="text-sm text-slate-500 mt-0.5">Pick a plan that fits your property size. Each plan runs for 3 months.</p>
      </div>

      <Card className="p-5 border-indigo-200 bg-gradient-to-br from-indigo-50 to-white" data-testid="subscription-current-plan">
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <span className="text-[10px] font-semibold uppercase tracking-widest text-indigo-600 bg-indigo-100 px-2 py-1 rounded-full">Current plan</span>
            <h3 className="font-display text-xl font-bold mt-2">Starter — Free</h3>
            <p className="text-sm text-slate-500 mt-0.5">Upgrade anytime to get a monthly receipt allowance.</p>
          </div>
          <div className="text-sm text-slate-600 text-right">
            <span className="font-display text-2xl font-bold text-indigo-700">{used}</span>
            <p className="text-xs">receipts generated in {stats?.current_month || "this month"}</p>
          </div>
        </div>
      </Card>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {PLANS.map((p) => (
          <Card key={p.name} className={`relative p-6 transition-shadow hover:shadow-md ${p.popular ? "border-violet-300 ring-1 ring-violet-200" : "border-slate-200"}`} data-testid={p.testid}>
            {p.popular && (
              <span className="absolute top-4 right-4 text-[10px] font-semibold uppercase tracking-widest text-violet-700 bg-violet-100 px-2 py-1 rounded-full">Most popular</span>
            )}
            <div className="h-10 w-10 rounded-lg flex items-center justify-center text-white" style={{ background: p.color }}>
              <Sparkles className="h-5 w-5" />
            </div>
            <h3 className="mt-3 font-display text-xl font-bold">{p.name}</h3>
            <p className="mt-1">
              <span className="font-display text-3xl font-bold text-slate-900">₹{p.price}</span>
              <span className="text-sm text-slate-500"> / 3 months</span>
            </p>
            <ul className="mt-4 space-y-2 text-sm text-slate-700">
              <li className="flex gap-2"><Check className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /> {p.monthly} receipts per month</li>
              <li className="flex gap-2"><Check className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /> {p.total} receipts total per 3 months</li>
              <li className="flex gap-2"><Check className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /> WhatsApp sharing + PDF downloads</li>
              <li className="flex gap-2"><Check className="h-4 w-4 text-emerald-600 shrink-0 mt-0.5" /> Custom logo, e-sign & terms on receipts</li>
            </ul>
            <Button className="mt-5 w-full text-white" style={{ background: p.color }} onClick={() => onNavigate?.("contact")} data-testid={`${p.testid}-choose-button`}>
              Choose {p.name}
            </Button>
          </Card>
        ))}
      </div>
    </div>
  );
}
